import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { FadeUp, SectionHeader } from "@/components/ui-primitives";

/**
 * Premium "trusted by" strip — typographic wordmarks treated as logos.
 * Uses Playfair Display + Outfit weight/letter-spacing variations to give
 * each partner its own monogram-like character without infringing real logos.
 */
const partners = [
  { name: "Yalıkavak Marina", style: "font-display italic tracking-tight" },
  { name: "D-MARIN", style: "font-sans font-bold tracking-[0.35em]" },
  { name: "Setur Marinas", style: "font-display tracking-wide" },
  { name: "Netsel Marmaris", style: "font-sans font-light tracking-[0.25em] uppercase text-[18px]" },
  { name: "Port Göcek", style: "font-display italic" },
  { name: "Çelebi Marina", style: "font-sans font-semibold tracking-[0.18em] uppercase text-[18px]" },
  { name: "Atakoy Marina", style: "font-display tracking-tight" },
  { name: "Milta Bodrum", style: "font-sans font-medium tracking-[0.22em] uppercase text-[18px]" },
  { name: "Türk Loydu", style: "font-display italic tracking-wide" },
  { name: "MYBA", style: "font-sans font-extrabold tracking-[0.4em]" },
];

const Wordmark = ({ name, className }) => (
  <span
    className={`text-2xl sm:text-[26px] text-navy/55 hover:text-brand transition-colors duration-500 whitespace-nowrap ${className}`}
  >
    {name}
  </span>
);

const PartnersStrip = () => {
  const { t } = useLanguage();
  // duplicate the list to create seamless marquee loop
  const loop = [...partners, ...partners];

  return (
    <section className="py-20 bg-cream border-y border-navy/10" data-testid="home-partners">
      <div className="px-6 sm:px-10 lg:px-16">
        <SectionHeader
          align="center"
          eyebrow="Partners · Marinas · Bodies"
          title={t.home.trustTitle}
          subtitle={t.home.trustSubtitle}
        />

        <FadeUp delay={0.15}>
          <div
            className="mt-14 relative overflow-hidden"
            style={{
              maskImage:
                "linear-gradient(90deg, transparent 0%, #000 12%, #000 88%, transparent 100%)",
              WebkitMaskImage:
                "linear-gradient(90deg, transparent 0%, #000 12%, #000 88%, transparent 100%)",
            }}
          >
            <div className="marquee-track">
              {loop.map((p, idx) => (
                <div
                  key={idx}
                  className="flex items-center mx-8 sm:mx-12 group"
                  data-testid={`partner-${idx}`}
                >
                  <Wordmark name={p.name} className={p.style} />
                  <span className="ml-8 sm:ml-12 w-1 h-1 bg-brand/60 rounded-full group-hover:bg-brand transition-colors" />
                </div>
              ))}
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};

export default PartnersStrip;
